import { formatImageUploadMaxFileSizeMessage } from '@repo/ui/constants/image-upload';

type ValidateSelectedFileOptions = {
  accept: string;
  maxFileSizeBytes?: number;
  onError?: (message: string) => void;
};

function reportFileError(message: string, onError?: (message: string) => void): void {
  if (onError) {
    onError(message);
    return;
  }
  console.error(message);
}

function isAcceptedFileType(file: File, accept: string): boolean {
  const fileType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();
  const acceptedTypes = accept.split(',').map(type => type.trim());

  return acceptedTypes.some(acceptedType => {
    if (acceptedType.includes('*')) {
      return fileType.startsWith(acceptedType.split('/')[0]);
    }
    if (acceptedType.startsWith('.')) {
      return fileName.endsWith(acceptedType);
    }
    return fileType === acceptedType;
  });
}

/**
 * Returns true when the file is valid and the caller should invoke onChange.
 */
export function validateSelectedFile(file: File, options: ValidateSelectedFileOptions): boolean {
  const { accept, maxFileSizeBytes, onError } = options;

  if (maxFileSizeBytes !== undefined && file.size > maxFileSizeBytes) {
    reportFileError(formatImageUploadMaxFileSizeMessage(maxFileSizeBytes), onError);
    return false;
  }

  if (!isAcceptedFileType(file, accept)) {
    reportFileError(`Please select a valid file type. Accepted: ${accept}`, onError);
    return false;
  }

  return true;
}
